import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useTranslation } from 'next-i18next';
import { Container } from '../../../../../../components/HotelDetailsOverlay/components/AmadeusRatingSection/components/ImageSlider/components/Container.js';
import { ImageGrid } from '../../../../../../components/ImageGrid/index.js';
export const ImageSlider = ({
  images,
  onClickImage
}) => {
  // @TODO this isn't the travelDetailsOverlay...
  const {
    t
  } = useTranslation('travelDetailsOverlay');
  return _jsx(Container, {
    children: _jsx(ImageGrid.Root, {
      style: {
        display: 'flex'
      },
      children: images.map((image, index) => {
        const highlighted = index === 0 && images.length > 1;
        return _jsx(ImageGrid.Item, {
          style: {
            width: '123px',
            height: '70px',
            scrollSnapAlign: 'start'
          },
          children: _jsx(ImageGrid.ImageButton, {
            dimmed: highlighted,
            image: _jsx(ImageGrid.Image, {
              src: image.src,
              alt: image.alt
            }),
            onClick: () => {
              onClickImage(index);
            },
            children: highlighted && t('tourOperatorImages.allImagesButton', {
              imageCount: images.length
            })
          })
        }, image.src);
      })
    })
  });
};